$(document).ready(function () {
    if ($('#page').attr('data-page-id') === 'candidate') {

        let searchTable = $('#search_table');
        let dateTableSearch = searchTable.DataTable({
            ajax: '/get-candidate-search/' + $('#id').val(),
            dataSrc: 'data',
            serverSide: true,
            responsive: true,
            paging:   false,
            ordering: false,
            info:     false,
            searching: false,
            columns: [
                { data: 'label', name: 'label' },
                // { data: 'action', name: 'action', searchable: false, sortable: false, responsivePriority: 1 }
            ]
        });

        let studyTable = $('#studies');
        let dateTableStudy = studyTable.DataTable({
            ajax: '/get-candidate-studies/' + $('#id').val(),
            dataSrc: 'data',
            // processing: true,
            serverSide: true,
            responsive: true,
            paging:   false,
            ordering: false,
            info:     false,
            searching: false,
            columns: [
                { data: 'id', name: 'id', responsivePriority: 1, visible: false },
                { data: 'uni', name: 'uni' },
                { data: 'fac', name: 'fac' },
                { data: 'candidate_study_semester', name: 'candidate_study_semester' },
                { data: 'deg', name: 'deg'},
                {
                    data: 'candidate_study_completed',
                    name: 'candidate_study_completed',
                    searchable: false,
                    render: function (e, action, data) {
                        if (data.candidate_study_completed === 1) {
                            return '<i class="fa-thin fa-square-check"></i>';
                        } else {
                            return '<i class="fa-thin fa-square"></i>';
                        }
                    }
                },
            ]
        });

        let orgTable = $('#orgs');
        let dateTableOrg = orgTable.DataTable({
            ajax: '/get-candidate-orgs/' + $('#id').val(),
            dataSrc: 'data',
            // processing: true,
            serverSide: true,
            responsive: true,
            paging:   false,
            ordering: false,
            info:     false,
            searching: false,
            columns: [
                { data: 'id', name: 'id', responsivePriority: 1, visible: false },
                { data: 'event_group_identifier', name: 'event_group_identifier' },
                { data: 'event_name', name: 'event_name' },
                { data: 'org_name', name: 'org_name' },
                { data: 'time', name: 'time', render: function (e, action, data) {
                    return '<input class="time" type="time" value="' + data.time + '" data-id="' + data.id + '"/><button type="button" class="btn  btn-sm btn-primary ml-2 change-time"><i class="fa-thin fa-floppy-disk"></i></button>';
                } },
                { data: 'action', name: 'action', searchable: false, sortable: false, responsivePriority: 1 }
            ]
        });

        orgTable.on('click', 'tbody tr', function (v) {
            let data = dateTableOrg.row(this).data();

            if (data) {
                if ($(v.target).hasClass('change-time') === true || $(v.target).parent().hasClass('change-time') === true) {
                    $.ajaxSetup({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                    });

                    $.ajax({
                        type: "POST",
                        data: {
                            "_token": $('meta[name="csrftoken"]').attr('content'),
                            "id": data.id,
                            "time": $('input[data-id="' + data.id + '"]').val()
                        },
                        url: '/change-time',
                        success: function(msg) {
                            dateTableOrg.ajax.reload();
                            if (msg.success === true) {
                                $('body').notification({
                                    type: 'info',
                                    title: 'Löschen erfolgreich',
                                    message: 'Die Zeit wurde erfolgreich geändert',
                                    autoClose: 4000
                                });
                            } else {
                                $('body').notification({
                                    type: 'error',
                                    title: 'Fehler',
                                    message: 'Der Datensatz konnte leider nicht geändert werden.',
                                    // autoClose: 4000
                                });
                            }
                        }
                    });
                } else if ($(v.target).hasClass('invite') === true || $(v.target).parent().hasClass('invite') === true) {
                    $.ajaxSetup({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                    });

                    $.ajax({
                        type: "GET",
                        data: {
                            "_token": $('meta[name="csrftoken"]').attr('content'),
                            "candidate_org_id": data.id
                        },
                        url: '/get-email-text',
                        success: function(msg) {
                            if (msg.result) {
                                $('#email_subject').val(msg.result.event_group_email_subject);
                                CKEDITOR.instances['email_text'].setData(msg.result.event_group_email_text);
                                CKEDITOR.instances['email_signature'].setData(msg.result.event_group_email_signature);
                                $("#invite-candidate").modal("show");

                                $('#modal-send').on('click', function () {

                                    $.ajaxSetup({
                                        headers: {
                                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                        }
                                    });

                                    $.ajax({
                                        type: "POST",
                                        data: {
                                            "_token": $('meta[name="csrftoken"]').attr('content'),
                                            subject: $('#email_subject').val(),
                                            body: CKEDITOR.instances['email_text'].getData(),
                                            signature: CKEDITOR.instances['email_signature'].getData(),
                                            candidate_email: $('#candidate_email').val(),
                                            candidate_org_id: data.id
                                        },
                                        url: '/send-mail',
                                        success: function(msg) {
                                            dateTableOrg.ajax.reload();

                                            $('body').notification({
                                                type: 'info',
                                                title: 'Erfolg',
                                                message: 'Die Mail wurde erfolgreich gesendet',
                                                autoClose: 4000
                                            });
                                        }
                                    });
                                })
                            } else {
                                $('body').notification({
                                    type: 'error',
                                    title: 'Fehler',
                                    message: 'Der Datensatz konnte leider nicht geladen werden.',
                                    // autoClose: 4000
                                });
                            }
                        }
                    });
                }
            }
        });

        $('.state').on('click', function (v) {
            let id = $(v.target).attr('data-candidate-id');

            if ($(v.target).hasClass('unchecked') === true || $(v.target).hasClass('checked') === true) {
                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                });

                $.ajax({
                    type: "POST",
                    data: {"_token": $('meta[name="csrftoken"]').attr('content')},
                    url: '/cv-check/' + id,
                    success: function(msg) {
                        if (msg.result === true) {
                            if ($(v.target).hasClass('unchecked')) {
                                $(v.target).addClass('d-none');
                                $('.checked').removeClass('d-none');
                            } else {
                                $(v.target).addClass('d-none');
                                $('.unchecked').removeClass('d-none');
                            }


                            $('body').notification({
                                type: 'info',
                                title: '',
                                message: 'Der Status wurde erfolgreich geändert.',
                                autoClose: 4000
                            });
                        } else {
                            $('body').notification({
                                type: 'error',
                                title: 'Fehler',
                                message: 'Der Status konnte leider nicht geändert werden.',
                            });
                        }
                    }
                });
            }
        })

        CKEDITOR.replace('email_text');
        CKEDITOR.replace('email_signature');
    }
});
